import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { DeleteDialogBoxComponent } from '../delete-dialog-box/delete-dialog-box.component';
import { ToastrService } from 'ngx-toastr';
import { finalize, Subscription, tap } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AnnouncementService } from '@edtech-ui/core/services/announcement-management/announcement.service';
import { ReceivedStudyMaterial, SentStudyMaterial, StudyMaterialResponse } from '@edtech-ui/core/models/material-upload/get-all-study-material';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'app-classroom-classwork-page',
	standalone: true,
	imports: [MatIconModule, MatMenuModule, CommonModule, MatButtonModule, MatTabsModule, MatProgressSpinnerModule
		, MatTooltipModule
	],
	templateUrl: './classroom-classwork-page.component.html',
	styleUrl: './classroom-classwork-page.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class ClassroomClassworkPageComponent {

	classroomId: number =0;
	subscription = new Subscription();
	_totalMaterialLength: number = 0;
	_studyMaterialReceived: ReceivedStudyMaterial[] = [];
	_studyMaterialSent: SentStudyMaterial[] = [];
    isStudyLoading = false;

	constructor(
		private route: ActivatedRoute,
		private dialog: MatDialog,
		private _toastr: ToastrService,
		private _announcementService: AnnouncementService,
	) {
		this.subscription.add(this._announcementService.reload$.pipe(tap(() => this.getAllStudyMaterialAnnouncement())).subscribe());
	}

	ngOnInit(): void {
		this.route.parent?.paramMap.subscribe(params => {
			const classroomId = params.get('id');
			if (classroomId) {
				this.classroomId = +classroomId;
			}
			this.getAllStudyMaterialAnnouncement();
		});
	}

	getAllStudyMaterialAnnouncement() {
		if (!this.classroomId) {
			this._toastr.error('classroomId is missing');
			return;
		}
		this.isStudyLoading = true;
		this.subscription.add(
			this._announcementService.getAllStudyMaterialAnnouncement(Number(this.classroomId)).pipe(
				finalize(() => { this.isStudyLoading = false })
			).subscribe({
				next: (response: StudyMaterialResponse) => {
					if (response.Success && response.Data) {
						this._studyMaterialSent = response.Data.sent || [];
						this._studyMaterialReceived = response.Data.received || [];
						this._totalMaterialLength = response.Data.total_material_count;
					} else {
						this._toastr.error(response.Message);
					}
				},
				error: () => this._toastr.error('Something went wrong fetching the study materials')
			})
		);
	}

	openDeleteDialogMaterialBox(announcementId: number) {
		this.dialog.open(DeleteDialogBoxComponent, {
			width: '360px',
			data: { announcementId }
		}).afterClosed().subscribe(result => {
			if (result == true) {
				this.deleteMaterialById(announcementId);
			}
		});
	}

	deleteMaterialById(announcementId: number) {
		this.subscription.add(
			this._announcementService.deleteMaterialById(announcementId).subscribe({
				next: () => {
					this._toastr.success('Announcement deleted successfully');
				}
			})
		);
	}

	convertToIST(utcDateString: string): string {
		if (!utcDateString) return '';
		const date = new Date(utcDateString + 'Z');
		return new Intl.DateTimeFormat('en-IN', {
			timeZone: 'Asia/Kolkata',
			dateStyle: 'medium',
			timeStyle: 'short'
		}).format(date);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}